// =============================================================================
// accessibility.js
// Site-wide DOM patches for accessibility issues that can't be fixed in Liquid
// because the markup comes from apps (Klaviyo, IntentIQ, ProductReviews/proRW,
// Instafeed) or Shopify-injected widgets.
//
// Cleaned up May 2026 — removed broken/over-broad patches that were causing
// regressions flagged by PowerMapper and EcomBack:
//   - Mass-assignment of role="button" to navigation links (broke link semantics
//     and silenced their focusable descendants)
//   - Mass-stripping of tabindex from descendants of every [role="button"]
//     (broke CC/AD/Transcript buttons inside any role=button ancestor)
//   - Mass-stripping of aria-label from div/span (broke gallery dialog,
//     country selectors, slider items)
//   - Two duplicate target="_blank" handlers passing a CSS class name to
//     aria-describedby (which only accepts IDs). The new-window warning is
//     now handled correctly in layout/theme.liquid (A3).
// =============================================================================

// --- Tracking-pixel images: mark as decorative so screen readers ignore them
$(document).ready(function () {
  $('img[src*="sync.intentiq.com"]').attr("alt", "").css("display", "none");
  $('img[src*="arttrk.com/pixel"]').attr("alt", "pixel image");
});

// --- Powered by Shopify link: provide a clean accessible name.
//     The "opens in new tab" warning is added globally by theme.liquid (A3).
$(document).ready(function () {
  $('a[href*="shopify.com?utm_campaign=poweredby"]').attr(
    "aria-label",
    "Powered by Shopify",
  );
});

// --- Slick carousel: the initial active slide gets a stray tabindex
$(document).ready(function () {
  var existCondition = setInterval(function () {
    if (
      $(".slide.slide--custom-initial.slick-slide.slick-current.slick-active")
        .length
    ) {
      clearInterval(existCondition);
      $(
        ".slide.slide--custom-initial.slick-slide.slick-current.slick-active",
      ).removeAttr("tabindex");
    }
  }, 200);
});

// --- Mark required form fields
$(document).ready(function () {
  $('[aria-label="Email"]').attr("aria-required", "true");
  $("#quantity").attr("aria-required", "true");
});


// --- Decorative whitespace spans: mark as presentational so SRs skip them
$(document).ready(function () {
  $("span")
    .filter(function () {
      return $(this).html() === "&nbsp;";
    })
    .attr("role", "none");
});

// --- Tmenu (mega-menu) hover styling. Visual only.
$(document).ready(function () {
  $(".tmenu_item_link").hover(
    function () {
      $(this)
        .find(".tmenu_product_title, .tmenu_product_price")
        .addClass("underline-hover");
    },
    function () {
      $(this)
        .find(".tmenu_product_title, .tmenu_product_price")
        .removeClass("underline-hover");
    },
  );
});

// --- Country selector (custom-select): when aria-activedescendant points to an
//     ID that lives outside the listbox, expose it via aria-owns.
$(document).ready(function () {
  $(".custom-select__listbox").each(function () {
    var $listbox = $(this);
    var activeDescendantId = $listbox.attr("aria-activedescendant");
    if (activeDescendantId === "annbar-localization-country-opt-0MobileNav") {
      var $activeDescendant = $("#" + activeDescendantId);
      if ($activeDescendant.length && !$listbox.has($activeDescendant).length) {
        $listbox.attr("aria-owns", activeDescendantId);
      }
    }
  });
});

// --- ProductReviews (proRW) cleanup: hide decorative bits and ensure stars
//     and slide children aren't tabbable.
$(document).ready(function () {
  $(".prorw-featured-link").css("display", "none");
  $(".prorw-fa-star").attr("tabindex", "-1");
  $(".prorw_splide_li").find("*").attr("tabindex", "-1");
  $(".prorw-verified-buyer").css("display", "none");
  $(".prorw_review_author_last_initial").css("display", "none");
  $(".prorw-featured-container > h5").css("display", "none");
});

// --- proRW preview badge link fix.
//     The badge markup wraps an empty <p class="prorw_preview_badge_setup"> in an
//     <a href="/pages/all-reviews">. Until proRW's JS fills the <p> with star markup,
//     the link has no accessible name (WCAG F89). The <p> also carries tabindex="0",
//     creating a second focus stop for the same link. Add an aria-label to the link
//     and strip the redundant tabindex.
$(document).ready(function () {
  $(".prorw_preview_badge_setup").each(function () {
    var $p = $(this);
    var $a = $p.closest("a");
    if ($a.length && !$a.attr("aria-label")) {
      $a.attr("aria-label", "Read product reviews");
    }
    $p.removeAttr("tabindex");
  });
});

// --- Size-guide table headers.
//     Size guides pasted into product descriptions use <td> for both column and
//     row headers, which triggers WCAG F91 (data table without <th>). Promote the
//     first row's cells to <th scope="col"> and the first column of each data row
//     to <th scope="row"> at runtime. Scoped to .table-responsive.dynamic so this
//     never touches genuine data tables that already have headers, and skipped if
//     any <th> is already present.
$(document).ready(function () {
  $(".table-responsive.dynamic table").each(function () {
    var $table = $(this);
    if ($table.find("th").length > 0) return; // already has headers, leave alone
    var $rows = $table.find("tr");
    $rows.each(function (rowIdx) {
      $(this)
        .children("td")
        .each(function (cellIdx) {
          var $td = $(this);
          var scope = null;
          if (rowIdx === 0) {
            scope = "col";
          } else if (cellIdx === 0) {
            scope = "row";
          }
          if (scope) {
            var $th = $("<th></th>").attr("scope", scope).html($td.html());
            if ($td.attr("class")) $th.attr("class", $td.attr("class"));
            if ($td.attr("id")) $th.attr("id", $td.attr("id"));
            if ($td.attr("colspan")) $th.attr("colspan", $td.attr("colspan"));
            if ($td.attr("rowspan")) $th.attr("rowspan", $td.attr("rowspan"));
            $td.replaceWith($th);
          }
        });
    });
  });
});

// --- Hide stray <img> elements that some templates leak into the body root
$(document).ready(function () {
  $("body.template-index > img, body.template-product > img").css(
    "display",
    "none",
  );
});

// --- Klaviyo: set alt on the late-injected popup image
setTimeout(function () {
  $(".kl-private-reset-css-Xuajs1").attr("alt", "Draft Top image");
}, 1900);

// --- Style override: bold any text in the .ql-font-kanit class
setTimeout(function () {
  $(".ql-font-kanit").each(function () {
    var text = $(this).text();
    $(this).html("<strong>" + text + "</strong>");
  });
}, 500);

// --- Instafeed (Instagram embed) cards: give each a unique label
$(document).ready(function () {
  setTimeout(function () {
    $(".instafeed-new-layout-item-container").each(function (index) {
      $(this).attr("aria-label", "Instagram feed image " + (index + 1));
    });
  }, 1800);
});

// --- ensureAlt: every <img> on the page should have an alt attribute. If a
//     template forgot one, fall back to data-alt, the nearest <img alt> in the
//     same media block, the title attribute, or the page heading.
(function () {
  function ensureAlt(img) {
    if (!img || img.hasAttribute("alt")) return;
    var candidate =
      img.getAttribute("data-alt") ||
      (img.closest("[data-media-id]") &&
        img.closest("[data-media-id]").querySelector("img[alt]") &&
        img
          .closest("[data-media-id]")
          .querySelector("img[alt]")
          .getAttribute("alt")) ||
      img.getAttribute("title") ||
      (document.querySelector("h1,h2,[data-product-title]") &&
        document
          .querySelector("h1,h2,[data-product-title]")
          .textContent.trim());
    if (candidate != null) img.setAttribute("alt", candidate);
  }

  document.querySelectorAll("img").forEach(ensureAlt);

  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      if (!added) continue;
      added.forEach(function (n) {
        if (n.nodeType === 1) {
          if (n.tagName === "IMG") ensureAlt(n);
          if (n.querySelectorAll) n.querySelectorAll("img").forEach(ensureAlt);
        }
      });
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

$(document).ready(function () {
  $(
    'img[src="https://sync.intentiq.com/profiles_engine/ProfilesEngineServlet?at=20&mi=10&secure=1&dpi=359446293&rnd=913945&pid=72oDmXJqNq&dbsaved=true&iiqidtype=2&iiqpcid=1ca63c4d-7d40-4d68-a3c1-ed48c9a9c177&iiqpciddate=1720616571613&tsrnd=811_1720661287685&pcid=767ce0fa-020e-4368-b621-2f2cf9fc8266-tuctd4fdb89&idtype=0&vrref=drafttop.com&jsver=5.4&abtp=100&abtg=A"]',
  ).attr("alt", "");
});

$(
  'a[href="https://www.shopify.com?utm_campaign=poweredby&utm_medium=shopify&utm_source=onlinestore"]',
).attr("aria-label", "Powered by Shopify,this link will open in a new tab");

$(document).ready(function () {
  var existCondition = setInterval(function () {
    if (
      $(".slide.slide--custom-initial.slick-slide.slick-current.slick-active")
        .length
    ) {
      clearInterval(existCondition);
      runMyFunctionrmvtb();
    }
  }, 200);

  function runMyFunctionrmvtb() {
    $(
      ".slide.slide--custom-initial.slick-slide.slick-current.slick-active",
    ).removeAttr("tabindex");
  }
});
$(document).ready(function () {
  $('[aria-label="Email"]').attr("aria-required", "true");
});
$(document).ready(function () {
  $("#quantity").attr("aria-required", "true");
});
$(document).ready(function () {
  $(".tmenu_item_link").attr("role", "button");
});
$(document).ready(function () {
  $(".shopify-payment-button__button").attr("role", "button");
});
$(document).ready(function () {
  $("span")
    .filter(function () {
      return $(this).html() === "&nbsp;";
    })
    .attr("role", "none");
});
$(document).ready(function () {
  function setRoleAttribute() {
    $(".tmenu_item_link").attr("role", "button");
  }

  setRoleAttribute(); // Run the function once on document ready

  // Set an interval to check and set the attribute repeatedly
  var intervalId = setInterval(function () {
    if ($(".tmenu_item_link").length) {
      setRoleAttribute();
      clearInterval(intervalId); // Clear the interval once the attribute is set
    }
  }, 100); // Check every 100 milliseconds
});

$(document).ready(function () {
  $(".tmenu_item_link").hover(
    function () {
      $(this)
        .find(".tmenu_product_title, .tmenu_product_price")
        .addClass("underline-hover");
    },
    function () {
      $(this)
        .find(".tmenu_product_title, .tmenu_product_price")
        .removeClass("underline-hover");
    },
  );
});

$(document).ready(function () {
  $(".prorw-verified-buyer").attr("role", "button");
});

// Example for adding aria-label to a button with icon
$(document).ready(function () {
  // Select the button by its class or ID
  $(".prorw-verified-buyer").each(function () {
    // Get the text or description for screen readers
    var buttonText = "This button verifies the buyer's status";

    // Add aria-label attribute with the description
    // $(this).attr('aria-label', buttonText);
  });
});

$(document).ready(function () {
  // Set tabindex="0" for elements with role="button"
  $('[role="button"]').attr("tabindex", "0");

  // Optionally, you can also handle click events for better keyboard accessibility
  $('[role="button"]').on("keydown", function (event) {
    // Trigger the click event on Enter key press
    if (event.which === 13 || event.which === 32) {
      // 13 is Enter, 32 is Spacebar
      $(this).click();
    }
  });
});

$(document).ready(function () {
  $(".custom-select__listbox").each(function () {
    var $listbox = $(this);

    // Get the value of aria-activedescendant
    var activeDescendantId = $listbox.attr("aria-activedescendant");

    // Check if aria-activedescendant is set to the specific ID
    if (activeDescendantId === "annbar-localization-country-opt-0MobileNav") {
      var $activeDescendant = $("#" + activeDescendantId);

      // If the active descendant is not a child of the listbox, use aria-owns
      if ($activeDescendant.length && !$listbox.has($activeDescendant).length) {
        $listbox.attr("aria-owns", activeDescendantId);
      }
    }
  });
});

// focus management for the search pop-up
$(document).on("click", ".main-search__close", function () {
  setTimeout(function () {
    var $searchButton = $('a.show-search-link[role="button"]').first();

    if (!$searchButton.length) return;

    $searchButton.attr("tabindex", "0");

    $searchButton[0].focus({
      preventScroll: true,
    });
  }, 1000);
});

// focus management for the cart focus
$(function () {
  var $drawer = $("cart-drawer");
  var lastTrigger = null;

  if (!$drawer.length) return;
  var triggerSelector =
    '.cart-link, [name="add"], .js-open-cart-drawer, [data-open-cart-drawer], a[href="#cart-drawer"], a[href$="/cart"]';

  $(document).on("click", triggerSelector, function (e) {
    lastTrigger = this;
  });

  var wasOpen = false;

  var observer = new MutationObserver(function () {
    var isOpen =
      $drawer.is("[open]") ||
      $drawer.hasClass("is-open") ||
      $drawer.hasClass("active") ||
      $drawer.attr("aria-hidden") === "false";

    handleStateChange(isOpen);
  });

  observer.observe($drawer[0], {
    attributes: true,
    attributeFilter: ["open", "class", "aria-hidden"],
  });

  function handleStateChange(isOpen) {
    if (isOpen && !wasOpen) {
      $drawer
        .find('button, [href], input, [tabindex]:not([tabindex="-1"])')
        .first()
        .trigger("focus");
    } else if (!isOpen && wasOpen) {
      if (lastTrigger && $.contains(document.body, lastTrigger)) {
        $(lastTrigger).trigger("focus");
      }
      lastTrigger = null;
    }
    wasOpen = isOpen;
  }
});

//Quick View focus management
$(document).on("click", ".quickbuy-toggle", function (e) {
  var $toggle = $(this);

  var $container = $();
  $toggle.parents().each(function () {
    var $found = $(this).find(".quickbuy-container").first();
    if ($found.length) {
      $container = $found;
      return false; //
    }
  });
  if (!$container.length) {
    console.warn(
      "No .quickbuy-container found as an ancestor of this .quickbuy-toggle",
      $toggle[0],
    );
    return;
  }
  var $closeBtn = $container.find("a.close-detail").first();
  if (!$closeBtn.length) {
    console.warn(
      "No a.close-detail found inside this .quickbuy-container",
      $container[0],
    );
    return;
  }
  $toggle.attr("aria-expanded", "true");

  var hasTransition = parseFloat($container.css("transition-duration")) > 0;

  var moveFocus = function () {
    $closeBtn.trigger("focus");
  };

  if (hasTransition) {
    $container.one("transitionend", moveFocus);
  } else {
    setTimeout(moveFocus, 50);
  }

  $closeBtn.one("click", function () {
    $toggle.attr("aria-expanded", "false");
    $toggle.trigger("focus");
  });
});

//for Quick view close button sayse
$(function () {
  function setQuickBuyState($container, isOpen) {
    if (!$container.length) return;

    var $closeButton = $container.find(".close-detail").first();
    if (isOpen) {
      $container.attr("aria-hidden", "false").removeAttr("inert");

      $closeButton.removeAttr("tabindex").removeAttr("aria-hidden");
    } else {
      $container.attr("aria-hidden", "true").attr("inert", "");
      $closeButton.attr("tabindex", "-1").attr("aria-hidden", "true");
    }
  }
  $(".quickbuy-container").each(function () {
    setQuickBuyState($(this), false);
  }); 
  $(document).on("on:quickbuy:before-open", ".quickbuy-container", function () {
    setQuickBuyState($(this), true);
  });
  $(document).on("on:quickbuy:after-close", ".quickbuy-container", function () {
    setQuickBuyState($(this), false);
  });
  $(document).on("click", ".close-detail", function () {
    setQuickBuyState($(this).closest(".quickbuy-container"), false);
  });
});

//aria-hidden for the gallery region on product page
$(document).ready(function () {

  function updateMediaGallery() {

    $('.media-gallery__inner .slider__item').each(function () {
      var $slide = $(this);

      $slide.removeAttr('tabindex');

      if ($slide.hasClass('is-active')) {

        $slide.removeAttr('aria-hidden');
        $slide.find('img').removeAttr('aria-hidden');

      } else {

        $slide.find('img').attr('aria-hidden', 'true');

      }
    });
  }

  updateMediaGallery();

  $('.media-gallery__inner').on(
    'transitionend',
    function () {
      updateMediaGallery();
    }
  );

  $(document).on(
    'click',
    '.media-gallery__inner button, .media-gallery__inner [role="button"]',
    function () {
      setTimeout(updateMediaGallery, 300);
    }
  );
});
